import { ProductId } from "../../enum/account"
import { useI18n } from 'vue-i18n'


export const UserRoleNameToIdMap = {
  /** 超级管理员 */
  ROLE_BUSINESS_SUPER_ADMIN:  1,
  ROLE_BUSINESS_ADMIN: 2,
  ROLE_BUSINESS_USER: 3,
  /** 招聘主管 */
  ROLE_BUSINESS_RECRUIT_MANAGER:  4,
  /** 招聘专员 */
  ROLE_BUSINESS_RECRUITER: 5,
  /** 面试官 */
  ROLE_BUSINESS_INTERVIEWER: 6,
  /** 运营支持 */
  ROLE_BUSINESS_OPERATION: 7,

  // 猎头端角色
  ROLE_AGENT_ADMIN: 2,
  ROLE_AGENT_USER: 3
}
// export enum SystemName {
//   'business'
// }
export enum System {
  business = 'business',
  agent = 'agent',
}
export enum SystemProductId {
  business = ProductId.ATS,
  agent = ProductId.AGENT,
}

export enum PermissionsAlias {
  hasAllPermission = 'has_all_permission'
}
export const SystemRole = {
  [System.business]: [
    UserRoleNameToIdMap.ROLE_BUSINESS_SUPER_ADMIN,
    UserRoleNameToIdMap.ROLE_BUSINESS_RECRUIT_MANAGER,
    UserRoleNameToIdMap.ROLE_BUSINESS_RECRUITER,
    UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER,
    UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION,
  ],
  [System.agent]: [
    UserRoleNameToIdMap.ROLE_BUSINESS_SUPER_ADMIN,
    UserRoleNameToIdMap.ROLE_AGENT_ADMIN,
    UserRoleNameToIdMap.ROLE_AGENT_USER,
    UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION,
  ]
}
export const SystemCanCreateRole = {
  [System.business]: [
    UserRoleNameToIdMap.ROLE_BUSINESS_RECRUIT_MANAGER,
    UserRoleNameToIdMap.ROLE_BUSINESS_RECRUITER,
    UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER,
    UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION,
  ],
  [System.agent]: [
    UserRoleNameToIdMap.ROLE_AGENT_ADMIN,
    UserRoleNameToIdMap.ROLE_AGENT_USER,
    UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION,
  ]
}
/**
 * 用户角色枚举
 */
export enum UserRole {
  /** 超级管理员 */
  SUPER_ADMIN = UserRoleNameToIdMap.ROLE_BUSINESS_SUPER_ADMIN,
  /** 管理员 */
  RECRUITMENT_MANAGER = UserRoleNameToIdMap.ROLE_BUSINESS_RECRUIT_MANAGER,
  /** hr */
  RECRUITMENT_SPECIALIST = UserRoleNameToIdMap.ROLE_BUSINESS_RECRUITER,
  /** 面试官 */
  INTERVIEWER = UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER,
  /** 运营支持 */
  ROLE_BUSINESS_OPERATION = UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION,

  // 猎头端角色
  ROLE_AGENT_ADMIN = UserRoleNameToIdMap.ROLE_AGENT_ADMIN,
  ROLE_AGENT_USER = UserRoleNameToIdMap.ROLE_AGENT_USER,

}
// 1, 'ROLE_BUSINESS_SUPER_ADMIN'
// 2, 'ROLE_BUSINESS_ADMIN'
// 3, 'ROLE_BUSINESS_USER'
// 4, 'ROLE_BUSINESS_RECRUIT_MANAGER'
// 5, 'ROLE_BUSINESS_RECRUITER'
// 6, 'ROLE_BUSINESS_INTERVIEWER'
// 与后端的角色名称对应
export enum UserRoleName {
  /** 超级管理员 */
  SUPER_ADMIN = 'ROLE_BUSINESS_SUPER_ADMIN',
  /** 招聘主管 */
  RECRUITMENT_MANAGER = 'ROLE_BUSINESS_RECRUIT_MANAGER',
  /** 招聘专员 */
  RECRUITMENT_SPECIALIST = 'ROLE_BUSINESS_RECRUITER',
  /** 面试官 */
  INTERVIEWER = 'ROLE_BUSINESS_INTERVIEWER',
  // 运营支持
  ROLE_BUSINESS_OPERATION = 'ROLE_BUSINESS_OPERATION',
}

/**
 * 权限操作类型
 */
export enum PermissionAction {
  /** 查看权限 */
  SHOW = 'show',
  /** 编辑/管理权限 */
  EDIT = 'edit',
  /** 下载权限 */
  DOWNLOAD = 'download',
  /** 消息通知设置权限 */
  NOTIFY_SETTING = 'notifySetting'
}

/**
 * 获取角色ID对应的国际化文案
 * @returns 角色ID到国际化文案的映射对象
 */
export const getRoleNameByIdMap = () => {
  const { t } = useI18n()

  return {
    // 企业端角色
    [UserRoleNameToIdMap.ROLE_BUSINESS_SUPER_ADMIN]: t('account.roles.superAdmin'),
    [UserRoleNameToIdMap.ROLE_BUSINESS_RECRUIT_MANAGER]: t('account.roles.recruitmentManager'),
    [UserRoleNameToIdMap.ROLE_BUSINESS_RECRUITER]: t('account.roles.recruitmentSpecialist'),
    [UserRoleNameToIdMap.ROLE_BUSINESS_INTERVIEWER]: t('account.roles.interviewer'),
    
    [UserRoleNameToIdMap.ROLE_BUSINESS_OPERATION]: t('account.roles.businessOp'),
    // 猎头端角色
    [UserRoleNameToIdMap.ROLE_AGENT_ADMIN]: t('account.roles.agentAdmin'),
    [UserRoleNameToIdMap.ROLE_AGENT_USER]: t('account.roles.agentUser'),
  }
}
